// extracted by mini-css-extract-plugin
export default {"container":"EditButton_container__CSqlR","button":"EditButton_button__ukLET"};